// extracted by css-extract-rspack-plugin
export default {"aiTranslationDropdown":"AiTranslationDropdown-aiTranslationDropdown_Vcx"};